import React from "react";
import { Anchor, Box } from "grommet";
import { Instagram, Twitter, Github } from "grommet-icons";

const SocialMedia = () => (
    <Box direction="row" gap="medium" justify="center">
        <Anchor
            a11yTitle="My Github"
            href="https://github.com/kelvinkhai"
            icon={<Github color="brand" size="medium" />}
        />
        <Anchor
            a11yTitle="My Instagram"
            href="https://www.instagram.com/khaizeee"
            icon={<Instagram color="brand" size="medium" />}
        />
        <Anchor
            a11yTitle="My Twitter"
            href="https://twitter.com/khaizeeeeee"
            icon={<Twitter color="brand" size="medium" />}
        />
    </Box>
);

export default SocialMedia;
